import request from "../helpers/request"

export const getNotifications = async (page = 1) => {
  const response = await request.get(`/api/company/notifications?page=${page}`)
  return response.data
}

export const markNotificationAsRead = async (notificationId) => {
  const response = await request.post(`/api/company/notifications/${notificationId}/mark-as-read`)
  return response.data
}

export const updateNotificationState = (count) => {
  localStorage.setItem('notificationCount', count)
  window.dispatchEvent(new CustomEvent('notificationUpdate', { detail: { count } }))
}

export const getNotificationState = () => {
  return parseInt(localStorage.getItem('notificationCount') || '0')
}